import isEqual from 'lodash/isEqual';

import { useEffect, useState } from 'react';
import { BehaviorSubject, OperatorFunction, Subject } from 'rxjs';

export function useStream<T>(
    observable: BehaviorSubject<T> | Subject<T>,
    ...pipeAble: OperatorFunction<any, any>[]
): [T, (newValue: T | ((oldValue: T) => T)) => T] {
    const [value, ownSetValue] = useState<T>();

    const setValue = (newValue: T | ((oldValue: T) => T)) => {
        if (newValue instanceof Function) {
            newValue = newValue(value);
        }
        if (!isEqual(newValue, value)) {
            observable?.next(newValue);
        }
        return newValue;
    };

    useEffect(() => {
        const subscription = observable?.pipe(...(pipeAble as [])).subscribe(ownSetValue);
        return () => subscription.unsubscribe();
    }, [observable]);

    return [value, setValue];
}
